module.exports = __webpack_public_path__ + "img/topimg.92ec9b19.png";